import React, { useContext, useEffect, useRef, useState } from "react";
import { MainContext } from "../App";
import functions from "../utilities/functions";
import { normalizeSelectedVariants } from "../utilities/selectedVariants";
import CloseIcon from "../icons/CloseIcon";
import Allergens from "./Allergens";

function VariantsPopup() {
	const { handleAddProduct, variantsPopup, setVariantsPopup, saveProduct } =
		useContext(MainContext);
	const INGREDIENTS_CATEGORY_KEY = "__ingredients__";
	const CATEGORY_SCROLL_TOP_GAP = 112;
	const CATEGORY_SCROLL_PROBE_GAP = 118;
	const [compressedOpen, setCompressedOpen] = useState({});
	const [activeCategoryKey, setActiveCategoryKey] = useState(null);
	const [highlightedCategoryKey, setHighlightedCategoryKey] = useState(null);
	const [showImagePreview, setShowImagePreview] = useState(false);
	const [infoSubproduct, setInfoSubproduct] = useState(null);
	const categoryRefs = useRef({});
	const contentRef = useRef(null);
	const categoriesNavRef = useRef(null);
	const categoriesNavScrollRef = useRef(null);
	const navItemRefs = useRef({});
	const noteTextareaRef = useRef(null);
	const highlightTimeoutRef = useRef(null);
	const buildDefaultSelectedVariants = () => {
		const categories = variantsPopup?.product?.variants_categories || [];
		let response = [];
		for (const variantsCategory of categories) {
			const hasPrice = Number(variantsCategory.has_price) === 1;
			let item = {
				id: variantsCategory.id,
				name: variantsCategory.name,
				force_mono: variantsCategory.force_mono || 0,
				tot: 0,
				variants: [],
				variants2: [],
				products: [],
				products2: [],
			};
			for (const variant of variantsCategory.variants || []) {
				item.variants.push({
					id: variant.id,
					name: variant.name,
					qty: 0,
					price: hasPrice ? variant.price : 0,
				});
			}
			for (const variant of variantsCategory.variants2 || []) {
				item.variants2.push({
					id: variant.id,
					name: variant.name,
					qty: variant.is_default > 0 ? 1 : 0,
					price: hasPrice ? variant.price : 0,
				});
			}
			for (const subproduct of variantsCategory.products || []) {
				item.products.push({
					id: subproduct.id,
					name: subproduct.name,
					qty: 0,
					price: hasPrice ? subproduct.price : 0,
				});
			}
			for (const subproduct of variantsCategory.products2 || []) {
				item.products2.push({
					id: subproduct.id,
					name: subproduct.name,
					qty: subproduct.is_default > 0 ? 1 : 0,
					price: hasPrice ? subproduct.price : 0,
				});
			}
			response.push(item);
		}
		return response;
	};
	const buildDefaultSelectedIngredients = () => {
		let response = [];
		for (const ingredient of variantsPopup?.product?.ingredients || []) {
			response.push({
				id: ingredient.id,
				name: ingredient.name,
				selected: true,
			});
		}
		return response;
	};
	const getInitialSelectedVariants = () => {
		if (variantsPopup.index !== false && Array.isArray(variantsPopup.product.selectedVariants)) {
			return normalizeSelectedVariants(JSON.parse(JSON.stringify(variantsPopup.product.selectedVariants)));
		}
		return buildDefaultSelectedVariants();
	};
	const getInitialSelectedIngredients = () => {
		if (
			variantsPopup.index !== false &&
			Array.isArray(variantsPopup.product.selectedIngredients)
		) {
			return JSON.parse(JSON.stringify(variantsPopup.product.selectedIngredients));
		}
		return buildDefaultSelectedIngredients();
	};
	const [selectedVariants, setSelectedVariants] = useState(getInitialSelectedVariants);
	const [selectedIngredients, setSelectedIngredients] = useState(getInitialSelectedIngredients);
	const [productNote, setProductNote] = useState(
		() => variantsPopup?.product?.notes || ""
	);
	const [valid, setValid] = useState(false);
	const [totals, setTotals] = useState(false);

	useEffect(() => {
		console.log("selectedIngredients se to", selectedIngredients);
	}, [selectedIngredients]);

	useEffect(() => {
		if (variantsPopup) checkVariants();
	}, [variantsPopup, selectedVariants]);

	useEffect(() => {
		const nextState = {};
		(variantsPopup?.product?.variants_categories || []).forEach((variantsCategory, index) => {
			nextState[getCategoryKey(variantsCategory, index)] = !isCompressedCategory(
				variantsCategory
			);
		});
		setSelectedVariants(getInitialSelectedVariants());
		setSelectedIngredients(getInitialSelectedIngredients());
		setCompressedOpen(nextState);
		const sections = getScrollableSections();
		setActiveCategoryKey(sections.length > 0 ? sections[0].key : null);
		setProductNote(variantsPopup?.product?.notes || "");
	}, [variantsPopup]);

	useEffect(() => {
		const container = contentRef.current;
		if (!container || getScrollableSections().length === 0) return;

		const onScroll = () => {
			updateActiveCategoryByScroll();
		};

		container.addEventListener("scroll", onScroll, { passive: true });
		window.requestAnimationFrame(onScroll);

		return () => {
			container.removeEventListener("scroll", onScroll);
		};
	}, [variantsPopup, compressedOpen]);

	useEffect(() => {
		if (!activeCategoryKey) return;
		alignActiveCategoryInNav();
	}, [activeCategoryKey]);

	useEffect(() => {
		return () => {
			if (highlightTimeoutRef.current) {
				window.clearTimeout(highlightTimeoutRef.current);
				highlightTimeoutRef.current = null;
			}
		};
	}, []);

	const checkVariants = () => {
		console.log("checkVariants");
		console.log(selectedVariants);
		let v = true;
		let i = 0;
		let t = [];
		for (const variants_vategory of variantCategories) {
			const currentCategory = selectedVariants[i] || {
				variants: [],
				variants2: [],
				products: [],
				products2: [],
			};
			let qty = 0;
			for (const selectetVariant of currentCategory.variants) qty += selectetVariant.qty;
			for (const selectetVariant of currentCategory.variants2) qty += selectetVariant.qty;
			for (const selectetSubproduct of currentCategory.products)
				qty += selectetSubproduct.qty;
			for (const selectetSubproduct of currentCategory.products2)
				qty += selectetSubproduct.qty;
			if (variants_vategory.min > 0) if (qty < variants_vategory.min) v = false;
			t.push(qty);
			i++;
		}
		console.log("v", v);
		console.log("t", t);
		setValid(v);
		setTotals(t);
	};

	const addVariant = (variantsCategoryIndex, variantIndex) => {
		console.log("addVariant");
		let arr = [...selectedVariants];
		arr[variantsCategoryIndex].tot++;
		arr[variantsCategoryIndex].variants[variantIndex].qty++;
		setSelectedVariants(arr);
	};

	const removeVariant = (variantsCategoryIndex, variantIndex) => {
		console.log("removeVariant");
		let arr = [...selectedVariants];
		if (arr[variantsCategoryIndex].variants[variantIndex].qty > 0) {
			arr[variantsCategoryIndex].tot--;
			arr[variantsCategoryIndex].variants[variantIndex].qty--;
		}
		setSelectedVariants(arr);
	};

	const addVariant2 = (variantsCategoryIndex, variantIndex) => {
		console.log("addVariant2");
		let arr = [...selectedVariants];
		arr[variantsCategoryIndex].tot++;
		arr[variantsCategoryIndex].variants2[variantIndex].qty++;
		setSelectedVariants(arr);
	};

	const removeVariant2 = (variantsCategoryIndex, variantIndex) => {
		console.log("removeVariant2");
		let arr = [...selectedVariants];
		if (arr[variantsCategoryIndex].variants2[variantIndex].qty > 0) {
			arr[variantsCategoryIndex].tot--;
			arr[variantsCategoryIndex].variants2[variantIndex].qty--;
		}
		setSelectedVariants(arr);
	};

	const addSubproduct = (variantsCategoryIndex, productIndex) => {
		console.log("addSubproduct");
		let arr = [...selectedVariants];
		arr[variantsCategoryIndex].tot++;
		arr[variantsCategoryIndex].products[productIndex].qty++;
		setSelectedVariants(arr);
	};

	const removeSubproduct = (variantsCategoryIndex, productIndex) => {
		console.log("removeSubproduct");
		let arr = [...selectedVariants];
		if (arr[variantsCategoryIndex].products[productIndex].qty > 0) {
			arr[variantsCategoryIndex].tot--;
			arr[variantsCategoryIndex].products[productIndex].qty--;
		}
		setSelectedVariants(arr);
	};

	const addSubproduct2 = (variantsCategoryIndex, productIndex) => {
		console.log("addSubproduct");
		let arr = [...selectedVariants];
		arr[variantsCategoryIndex].tot++;
		arr[variantsCategoryIndex].products2[productIndex].qty++;
		setSelectedVariants(arr);
	};

	const removeSubproduct2 = (variantsCategoryIndex, productIndex) => {
		console.log("removeSubproduct");
		let arr = [...selectedVariants];
		if (arr[variantsCategoryIndex].products2[productIndex].qty > 0) {
			arr[variantsCategoryIndex].tot--;
			arr[variantsCategoryIndex].products2[productIndex].qty--;
		}
		setSelectedVariants(arr);
	};

	const handleIngredients = (index, value) => {
		console.log("handleIngredients");
		if (!Array.isArray(selectedIngredients) || !selectedIngredients[index]) return;
		let arr = [...selectedIngredients];
		arr[index].selected = value;
		setSelectedIngredients(arr);
	};

	const getTotalPrice = () => {
		let extra = 0;
		for (const variantsCategory of selectedVariants || []) {
			for (const key of ["variants", "variants2", "products", "products2"]) {
				for (const item of variantsCategory[key] || []) {
					extra += (parseFloat(item.price) || 0) * (parseInt(item.qty) || 0);
				}
			}
		}
		return (parseFloat(variantsPopup?.product?.price) || 0) + extra;
	};

	const totalPrice = getTotalPrice();

	const getCategoryKey = (variantsCategory, index) =>
		`${variantsCategory?.id || "vc"}-${index}`;

	const isCompressedCategory = (variantsCategory) => {
		const compressedValue =
			variantsCategory?.compressed ??
			variantsCategory?.is_compressed ??
			variantsCategory?.isCompressed ??
			variantsCategory?.meta?.compressed ??
			variantsCategory?.data?.compressed;

		if (typeof compressedValue === "boolean") return compressedValue;
		if (typeof compressedValue === "number") return compressedValue === 1;
		if (typeof compressedValue === "string") {
			const normalized = compressedValue.trim().toLowerCase();
			if (normalized === "1" || normalized === "true" || normalized === "yes")
				return true;
			if (normalized === "0" || normalized === "false" || normalized === "no")
				return false;
		}

		const directValue =
			variantsCategory?.["data-name"] ||
			variantsCategory?.data_name ||
			variantsCategory?.dataName ||
			variantsCategory?.data?.["data-name"] ||
			variantsCategory?.data?.data_name ||
			variantsCategory?.meta?.["data-name"] ||
			variantsCategory?.meta?.data_name;

		if (
			typeof directValue === "string" &&
			directValue.trim().toLowerCase() === "compressed"
		)
			return true;

		const attrs = variantsCategory?.attributes || variantsCategory?.data_attributes || [];
		if (Array.isArray(attrs)) {
			return attrs.some((attr) => {
				const name = String(attr?.name || attr?.key || "").trim().toLowerCase();
				const value = String(attr?.value || "").trim().toLowerCase();
				return name === "data-name" && value === "compressed";
			});
		}
		return false;
	};

	const toggleCompressedCategory = (variantsCategory, index) => {
		const key = getCategoryKey(variantsCategory, index);
		setCompressedOpen((prev) => ({
			...prev,
			[key]: !prev[key],
		}));
	};

	const isRequiredCategory = (variantsCategory) =>
		(parseInt(variantsCategory?.min || 0) || 0) > 0;

	const variantCategories = variantsPopup?.product?.variants_categories || [];
	const hasIngredientsCategory = (variantsPopup?.product?.ingredients?.length || 0) > 0;
	const showCategoriesNav = variantCategories.length > 0;
	const showProductNoteEditor = true;

	const getScrollableSections = () => {
		const variantSections = variantCategories.map((variantsCategory, index) => ({
			key: getCategoryKey(variantsCategory, index),
		}));
		if (hasIngredientsCategory) {
			variantSections.push({ key: INGREDIENTS_CATEGORY_KEY });
		}
		return variantSections;
	};

	const updateActiveCategoryByScroll = () => {
		const container = contentRef.current;
		const sections = getScrollableSections();
		if (!container || sections.length === 0) return;

		const navHeight = categoriesNavRef.current?.offsetHeight || 0;
		const probePosition = container.scrollTop + navHeight + CATEGORY_SCROLL_PROBE_GAP;
		let currentKey = sections[0].key;

		for (const section of sections) {
			const el = categoryRefs.current[section.key];
			if (!el) continue;
			if (el.offsetTop <= probePosition) currentKey = section.key;
			else break;
		}

		setActiveCategoryKey((prev) => (prev === currentKey ? prev : currentKey));
	};

	const alignActiveCategoryInNav = () => {
		const navScroll = categoriesNavScrollRef.current;
		const navItem = navItemRefs.current[activeCategoryKey];
		if (!navScroll || !navItem) return;
		const left = Math.max(navItem.offsetLeft - 2, 0);
		navScroll.scrollTo({
			left,
			behavior: "smooth",
		});
	};

	const scrollToCategory = (categoryKey) => {
		const container = contentRef.current;
		const el = categoryRefs.current[categoryKey];
		if (!el) return;
		setHighlightedCategoryKey(categoryKey);
		if (highlightTimeoutRef.current) window.clearTimeout(highlightTimeoutRef.current);
		highlightTimeoutRef.current = window.setTimeout(() => {
			setHighlightedCategoryKey((prev) => (prev === categoryKey ? null : prev));
			highlightTimeoutRef.current = null;
		}, 700);
		if (container) {
			const navHeight = categoriesNavRef.current?.offsetHeight || 0;
			const targetTop = Math.max(el.offsetTop - navHeight - CATEGORY_SCROLL_TOP_GAP, 0);
			container.scrollTo({ top: targetTop, behavior: "smooth" });
			setActiveCategoryKey(categoryKey);
			return;
		}
		el.scrollIntoView({ behavior: "smooth", block: "start" });
	};

	const handleSaveNote = () => {
		noteTextareaRef.current?.blur();
	};

	// Nome del sottoprodotto con icone allergeni e tasto info (la descrizione si vede solo nella scheda info)
	const renderSubproductName = (subproduct) => (
		<div className="variant-row-name subproduct-row-name">
			<span>{subproduct.name}</span>
			{subproduct.allergens?.length > 0 && (
				<span className="subproduct-allergens">
					<Allergens allergens={subproduct.allergens} iconsOnly />
				</span>
			)}
			<button
				type="button"
				className="subproduct-info-button"
				onClick={(e) => {
					e.stopPropagation();
					setInfoSubproduct(subproduct);
				}}
			>
				i
			</button>
		</div>
	);

	const renderCategoryRows = (variants_vategory, i) => {
		const hasPrice = Number(variants_vategory.has_price) === 1;
		return (
		<>
			{variants_vategory.variants.map((variant, n) => (
				<div key={n} className="list-button variant-row">
					<div className="variant-row-info">
						<div className="variant-row-name">{variant.name}</div>
						{hasPrice && (
							<div className="variant-row-price">
								{functions.formatter.format(variant.price)}
							</div>
						)}
					</div>
					<div className="buttons-group variant-row-controls">
						{selectedVariants[i].variants[n].qty > 0 ? (
							<button
								onClick={() => removeVariant(i, n)}
								className="btn btn-primary btn-square"
							>
								&#8722;
							</button>
						) : (
							<button className="btn btn-square">&#8722;</button>
						)}
						<div>{selectedVariants[i].variants[n].qty}</div>
						{totals[i] < variants_vategory.max ? (
							<button
								onClick={() => addVariant(i, n)}
								className="btn btn-primary btn-square"
							>
								&#43;
							</button>
						) : (
							<button className="btn btn-square">&#43;</button>
						)}
					</div>
				</div>
			))}
			{variants_vategory.variants2.map((variant, n) => (
				<div key={n} className="list-button variant-row">
					<div className="variant-row-info">
						<div className="variant-row-name">{variant.name}</div>
						{hasPrice && (
							<div className="variant-row-price">
								{functions.formatter.format(variant.price)}
							</div>
						)}
					</div>
					<div className="buttons-group variant-row-controls">
						{selectedVariants[i].variants2[n].qty > 0 ? (
							<button
								onClick={() => removeVariant2(i, n)}
								className="btn btn-primary btn-square"
							>
								&#8722;
							</button>
						) : (
							<button className="btn btn-square">&#8722;</button>
						)}
						<div>{selectedVariants[i].variants2[n].qty}</div>
						{totals[i] < variants_vategory.max ? (
							<button
								onClick={() => addVariant2(i, n)}
								className="btn btn-primary btn-square"
							>
								&#43;
							</button>
						) : (
							<button className="btn btn-square">&#43;</button>
						)}
					</div>
				</div>
			))}
			{variants_vategory.products.map((subproduct, n) => (
				<div key={n} className="list-button variant-row">
					<div className="variant-row-info">
						{renderSubproductName(subproduct)}
						{hasPrice && (
							<div className="variant-row-price">
								{functions.formatter.format(subproduct.price)}
							</div>
						)}
					</div>
					<div className="buttons-group variant-row-controls">
						{selectedVariants[i].products[n].qty > 0 ? (
							<button
								onClick={() => removeSubproduct(i, n)}
								className="btn btn-tertiary btn-square"
							>
								&#8722;
							</button>
						) : (
							<button className="btn btn-square">&#8722;</button>
						)}
						<div>{selectedVariants[i].products[n].qty}</div>
						{totals[i] < variants_vategory.max ? (
							<button
								onClick={() => addSubproduct(i, n)}
								className="btn btn-tertiary btn-square"
							>
								&#43;
							</button>
						) : (
							<button className="btn btn-square">&#43;</button>
						)}
					</div>
				</div>
			))}
			{variants_vategory.products2.map((subproduct, n) => (
				<div key={n} className="list-button variant-row">
					<div className="variant-row-info">
						{renderSubproductName(subproduct)}
						{hasPrice && (
							<div className="variant-row-price">
								{functions.formatter.format(subproduct.price)}
							</div>
						)}
					</div>
					<div className="buttons-group variant-row-controls">
						{selectedVariants[i].products2[n].qty > 0 ? (
							<button
								onClick={() => removeSubproduct2(i, n)}
								className="btn btn-tertiary btn-square"
							>
								&#8722;
							</button>
						) : (
							<button className="btn btn-square">&#8722;</button>
						)}
						<div>{selectedVariants[i].products2[n].qty}</div>
						{totals[i] < variants_vategory.max ? (
							<button
								onClick={() => addSubproduct2(i, n)}
								className="btn btn-tertiary btn-square"
							>
								&#43;
							</button>
						) : (
							<button className="btn btn-square">&#43;</button>
						)}
					</div>
				</div>
			))}
		</>
		);
	};

	return (
		<div className="popup lg variants-popup">
			<div className="container variants-popup-container">
				<header>
					<div className="buttons-group">
						<div className="popup-title-with-image">
							{variantsPopup.product.img && (
								<button
									type="button"
									className="popup-header-image-trigger"
									onClick={() => setShowImagePreview(true)}
								>
									<img
										src={variantsPopup.product.img}
										alt={variantsPopup.product.name}
									/>
								</button>
							)}
							<div>{variantsPopup.product.name}</div>
						</div>
					</div>
					<div className="buttons-group">
						<button
							className="btn btn-tertiary btn-square"
							onClick={() => setVariantsPopup(false)}
						>
							<CloseIcon />
						</button>
					</div>
				</header>
				<div
					className="content product-sheet product-sheet-content list-variants variants-content"
					ref={contentRef}
				>
					{(variantsPopup.product.description ||
						(variantsPopup.product.allergens?.length || 0) > 0) && (
							<div className="text-box product-description">
								<div className="title">Descrizione</div>
								{variantsPopup.product.description && (
									<div
										className="small"
										dangerouslySetInnerHTML={{
											__html: variantsPopup.product.description,
										}}
									/>
								)}
								{variantsPopup.product.allergens?.length > 0 && (
									<div className="product-description-allergens-inline">
										<div className="allergens">
											<Allergens allergens={variantsPopup.product.allergens} />
										</div>
									</div>
								)}
							</div>
						)}
					{showProductNoteEditor && (
						<div className="variant-note-editor text-box">
							<div className="variant-note-editor-head">
								<div className="title">Aggiungi una nota al prodotto</div>
								<button
									type="button"
									className="btn btn-tertiary variant-note-save-btn"
									onClick={handleSaveNote}
								>
									Salva
								</button>
							</div>
							<textarea
								ref={noteTextareaRef}
								value={productNote}
								onChange={(e) => setProductNote(e.target.value)}
								placeholder="Aggiungi una nota per questo prodotto"
							/>
						</div>
					)}
					{showCategoriesNav && (
						<div className="variant-categories-nav" ref={categoriesNavRef}>
							<div className="variant-categories-nav-scroll" ref={categoriesNavScrollRef}>
								{variantCategories.map((variants_vategory, i) => {
									const categoryKey = getCategoryKey(variants_vategory, i);
									return (
										<button
											key={categoryKey}
											type="button"
											ref={(el) => {
												navItemRefs.current[categoryKey] = el;
											}}
											className={
												"variant-categories-nav-item" +
												(activeCategoryKey === categoryKey
													? " variant-categories-nav-item-active"
													: "") +
												(isRequiredCategory(variants_vategory)
													? " variant-categories-nav-item-required"
													: "")
											}
											onClick={() => scrollToCategory(categoryKey)}
										>
											{variants_vategory.name}
										</button>
									);
								})}
								{hasIngredientsCategory && (
									<button
										key={INGREDIENTS_CATEGORY_KEY}
										type="button"
										ref={(el) => {
											navItemRefs.current[INGREDIENTS_CATEGORY_KEY] = el;
										}}
										className={
											"variant-categories-nav-item" +
											(activeCategoryKey === INGREDIENTS_CATEGORY_KEY
												? " variant-categories-nav-item-active"
												: "")
										}
										onClick={() => scrollToCategory(INGREDIENTS_CATEGORY_KEY)}
								>
									Rimuovi ingredienti
								</button>
							)}
						</div>
					</div>
					)}
					{variantCategories.map((variants_vategory, i) => (
						<div
							key={i}
							className={
								"variant-category" +
								(highlightedCategoryKey === getCategoryKey(variants_vategory, i)
									? " section-flash"
									: "")
							}
							ref={(el) => {
								categoryRefs.current[getCategoryKey(variants_vategory, i)] = el;
							}}
						>
							{(() => {
								const isOpen = !!compressedOpen[getCategoryKey(variants_vategory, i)];
								return (
									<div
										className={
											"variant-category-section" +
											(totals[i] < variants_vategory.min ? " required-invalid" : "")
										}
									>
										<button
											type="button"
											className="variant-category-toggle"
											onClick={() => toggleCompressedCategory(variants_vategory, i)}
										>
											<div className="variant-category-toggle-text">
												<div className="title">{variants_vategory.name}</div>
												<div className="small">
													Min: {variants_vategory.min} - Max: {variants_vategory.max}
												</div>
											</div>
											<div className="variant-category-toggle-right">
												<span className="variant-category-selected">
													{totals[i] || 0}
												</span>
												<span className="variant-category-toggle-action">
													{isOpen ? "Comprimi" : "Espandi"}
												</span>
											</div>
										</button>
										{isOpen && renderCategoryRows(variants_vategory, i)}
									</div>
								);
							})()}
						</div>
					))}
					{variantsPopup.product.ingredients.length > 0 && (
						<div
							className={
								"variant-category ingredients-category" +
								(highlightedCategoryKey === INGREDIENTS_CATEGORY_KEY
									? " section-flash"
									: "")
							}
							ref={(el) => {
								categoryRefs.current[INGREDIENTS_CATEGORY_KEY] = el;
							}}
						>
							<div className="variant-category-section">
								<div className="variant-category-toggle variant-category-toggle-static">
									<div className="variant-category-toggle-text">
										<div className="title">Rimuovi ingredienti</div>
									</div>
								</div>

								<div className="ingredients-list">
									{variantsPopup.product.ingredients.map((ingredient, n) => (
										<label
											key={n}
											className={
												"ingredient-item" + (ingredient.removable != 1 ? " is-fixed" : "")
											}
											htmlFor={"ingredient-" + n}
										>
											<input
												id={"ingredient-" + n}
												className="ingredient-checkbox"
												type="checkbox"
												checked={selectedIngredients?.[n]?.selected !== false}
												onChange={(e) => handleIngredients(n, e.target.checked)}
												disabled={ingredient.removable != 1}
											/>
											<span className="ingredient-checkbox-ui" aria-hidden="true"></span>
											<span className="ingredient-name">{ingredient.name}</span>
										</label>
									))}
								</div>
							</div>
						</div>
					)}
				</div>
				<div className="variants-addButton variants-footer">
					<div className="variants-footer-total">
						{functions.formatter.format(totalPrice)}
					</div>
					{valid ? (
						<>
							{variantsPopup.index === false ? (
								<button
									onClick={() =>
										handleAddProduct(
											variantsPopup.product,
											selectedVariants,
											selectedIngredients,
											false,
											productNote
										)
									}
									className="btn btn-primary variants-footer-action"
								>
									Aggiungi
								</button>
							) : (
								<button
									onClick={() => {
										const updatedProduct = {
											...variantsPopup.product,
											selectedVariants,
											selectedIngredients,
											notes: productNote,
										};
										saveProduct(variantsPopup.index, updatedProduct);
									}}
									className="btn btn-primary variants-footer-action"
								>
									Salva modifiche
								</button>
							)}
						</>
					) : (
						<button className="btn variants-footer-action" disabled>
							Effettua tutte le scelte
						</button>
					)}
				</div>
			</div>
			{showImagePreview && variantsPopup.product.img && (
				<div className="image-lightbox" onClick={() => setShowImagePreview(false)}>
					<button
						type="button"
						className="btn btn-tertiary btn-square image-lightbox-close"
						onClick={() => setShowImagePreview(false)}
					>
						<CloseIcon />
					</button>
					<img
						src={variantsPopup.product.img}
						alt={variantsPopup.product.name}
						onClick={(e) => e.stopPropagation()}
					/>
				</div>
			)}
			{infoSubproduct && (
				<div className="subproduct-info-overlay" onClick={() => setInfoSubproduct(null)}>
					<div className="subproduct-info-box" onClick={(e) => e.stopPropagation()}>
						<header>
							<div>{infoSubproduct.name}</div>
							<button
								type="button"
								className="btn btn-tertiary btn-square"
								onClick={() => setInfoSubproduct(null)}
							>
								<CloseIcon />
							</button>
						</header>
						<div className="subproduct-info-content">
							{infoSubproduct.img && (
								<div className="subproduct-info-img">
									<img src={infoSubproduct.img} alt={infoSubproduct.name} />
								</div>
							)}
							{infoSubproduct.description && (
								<div className="subproduct-info-section">
									<div className="title">Descrizione</div>
									<div
										className="small"
										dangerouslySetInnerHTML={{
											__html: infoSubproduct.description,
										}}
									/>
								</div>
							)}
							{infoSubproduct.allergens?.length > 0 && (
								<div className="subproduct-info-section">
									<div className="title">Allergeni</div>
									<div className="allergens">
										<Allergens allergens={infoSubproduct.allergens} />
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default VariantsPopup;
